import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200 flex justify-between" }
const _hoisted_2 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass([
                                    'ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium inline-block bg-gray-100 text-gray-900',
                                ])
}
const _hoisted_3 = {
  key: 1,
  class: "bg-primary-500 w-full inline-block h-1 rounded-tl rounded-tr absolute bottom-0 left-0"
}
const _hoisted_4 = { class: "px-7 flex items-center space-x-2" }

import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import { useRouter } from 'vue-router';
import { useNetworkStore } from '@/store/network';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TabComponent',
  props: {
    tabs: {
        type: Object,
        default: () => ({})
    },
    buttonItems: {
        type: Boolean,
        default: false,
    },
    href: {
        type: String,
        default: null,
    }
},
  setup(__props) {

// import { ref } from 'vue'


const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const router = useRouter();
const currentRoutePath = router.currentRoute.value.path;

const visitPage = (href: string) => {
    if(isNetworkAvailable.value) {
        window.location.assign(href)
    } else {
        router.push(href);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TabGroup), null, {
      default: _withCtx(() => [
        _createVNode(_unref(TabList), { class: "flex space-x-2 px-7" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tab.name
              }, [
                (tab.allowed)
                  ? (_openBlock(), _createBlock(_unref(Tab), {
                      key: 0,
                      as: "template",
                      onClick: ($event: any) => (visitPage(tab.href))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass([
                            _unref(currentRoutePath) == tab.href
                                ? 'text-primary-600'
                                : 'text-gray-500 hover:text-gray-700 hover:border-gray-200',
                            'whitespace-nowrap flex py-4 px-1 font-medium text-sm cursor-pointer relative ring-0 outline-none',
                        ])
                        }, [
                          _createTextVNode(_toDisplayString(tab.name) + " ", 1),
                          (tab.count)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(tab.count), 1))
                            : _createCommentVNode("", true),
                          (_unref(currentRoutePath) == tab.href)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanels), { class: "mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabPanel))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (__props.buttonItems)
        ? _renderSlot(_ctx.$slots, "buttons", { key: 0 })
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})